const Footer = () => (
  <footer data-testid="footer" className="bg-ink px-6 pb-10 pt-24 lg:px-12 lg:pt-32">
    <div className="mx-auto max-w-[1500px]">
      <div className="grid grid-cols-1 gap-12 border-b border-white/10 pb-16 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <div className="font-serif text-5xl font-semibold tracking-tight text-white lg:text-6xl">
            Prospera
          </div>
          <p className="mt-6 max-w-sm text-base font-light leading-relaxed text-white/50">
            An AI Business Optimization Firm. We engineer intelligence into the
            way enterprises operate.
          </p>
        </div>
        <div className="lg:col-span-3">
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">Navigate</div>
          <ul className="mt-6 space-y-3">
            {["services", "approach", "contact"].map((id) => (
              <li key={id}>
                <button
                  onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })}
                  className="font-light capitalize text-white/70 transition-colors hover:text-cobalt"
                >
                  {id}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">Contact</div>
          <ul className="mt-6 space-y-3 text-white/70">
            <li><a href="mailto:hello@prospera.ai" className="font-light transition-colors hover:text-cobalt">hello@prospera.ai</a></li>
            <li className="font-light">London · New York · Singapore</li>
          </ul>
        </div>
      </div>
      <div className="flex flex-col items-start justify-between gap-4 pt-8 sm:flex-row sm:items-center">
        <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-white/30">
          © {new Date().getFullYear()} Prospera. All rights reserved.
        </span>
        <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-white/30">
          Intelligence, operationalized.
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
